/**
 * The date that matters for a work order in its current status (#3765).
 *
 * One rule for the staff portal's list column and the list route's
 * `statusDate` sort, so the order of the rows always matches the dates the
 * column prints. Each status names its fields in priority order; the first
 * non-empty one wins, and `updatedAt` closes every chain so an imported row
 * without the lifecycle stamp still shows when it last changed.
 */
/** Booking timestamps the list exposes, in lifecycle order (the tooltip's order). */
export const WORK_ORDER_DATE_FIELDS = [
    'createdAt',
    'quoteExpiresAt',
    'confirmedAt',
    'scheduledAt',
    'vehicleDropoffAt',
    'startedAt',
    'pausedAt',
    'expectedResumeAt',
    'completedAt',
    'customerRequestedPickupAt',
    'signedAt',
    'invoicedAt',
    'updatedAt',
];
/** Closes every chain, and is the whole chain for a status not listed below. */
export const STATUS_DATE_FALLBACK_FIELD = 'updatedAt';
/** Status → fields in priority order, before the `updatedAt` fallback. */
export const STATUS_DATE_FIELDS = {
    quote: ['quoteExpiresAt', 'createdAt'],
    pending: ['scheduledAt'],
    confirmed: ['scheduledAt'],
    vehicle_arrived: ['vehicleDropoffAt', 'scheduledAt'],
    in_progress: ['startedAt', 'scheduledAt'],
    waiting_approval: ['startedAt', 'scheduledAt'],
    paused: ['expectedResumeAt', 'pausedAt', 'startedAt'],
    waiting_parts: ['expectedResumeAt', 'pausedAt', 'startedAt'],
    work_completed: ['completedAt'],
    ready_to_invoice: ['completedAt'],
    on_consolidated_invoice: ['completedAt'],
    completed: ['completedAt'],
    invoiced: ['invoicedAt', 'completedAt'],
};
/** The full chain for a status, fallback included. */
export function statusDateFields(status) {
    const fields = Object.prototype.hasOwnProperty.call(STATUS_DATE_FIELDS, status)
        ? STATUS_DATE_FIELDS[status] ?? []
        : [];
    return [...fields, STATUS_DATE_FALLBACK_FIELD];
}
/** First non-empty date in the status's chain; null only when even `updatedAt` is missing. */
export function resolveStatusDate(status, dates) {
    for (const field of statusDateFields(status)) {
        const value = dates[field];
        if (value)
            return { field, value };
    }
    return null;
}
/** Every non-empty date, in lifecycle order. */
export function listWorkOrderDates(dates) {
    const result = [];
    for (const field of WORK_ORDER_DATE_FIELDS) {
        const value = dates[field];
        if (value)
            result.push({ field, value });
    }
    return result;
}
//# sourceMappingURL=work-order-status-date.js.map